// Classes
import { createMonster } from "../monsterFactory";
import Potion, { POTION_LIST } from "../potion"
import { EQUIPMENT_LIST } from "../equipment";

// STATS =======================================================================

export const DEFAULT_STATS = { health: 30, maxHealth: 50, mana: 20, maxMana: 30 };

export const STATS = {
    STRENGTH: {
        ID: 'strength',
        NAME: 'Force'
    },
    INTELLIGENCE: {
        ID: 'intelligence',
        NAME: 'Intelligence'
    },
    DEXTERITY: {
        ID: 'dexterity',
        NAME: 'Dextérité'
    },
    VITALITY: {
        ID: 'vitality',
        NAME: 'Vitalité'
    }
}

export const BASE_STATS = {
    ARCHER: { ...DEFAULT_STATS, ...{ [STATS.STRENGTH.ID]: 1, [STATS.INTELLIGENCE.ID]: 2, [STATS.DEXTERITY.ID]: 4, [STATS.VITALITY.ID]: 2 } },
    SWORDER: { ...DEFAULT_STATS, ...{ [STATS.STRENGTH.ID]: 5, [STATS.INTELLIGENCE.ID]: 0, [STATS.DEXTERITY.ID]: 2, [STATS.VITALITY.ID]: 2 } },
    MAGE: { ...DEFAULT_STATS, ...{ [STATS.STRENGTH.ID]: 1, [STATS.INTELLIGENCE.ID]: 4, [STATS.DEXTERITY.ID]: 2, [STATS.VITALITY.ID]: 2 } },
    TANK: { ...DEFAULT_STATS, ...{ [STATS.STRENGTH.ID]: 3, [STATS.INTELLIGENCE.ID]: 1, [STATS.DEXTERITY.ID]: 1, [STATS.VITALITY.ID]: 4 } },
    MONSTER: { health: 20, maxHealth: 25, mana: 10, maxMana: 15 },
}

// HEROES =====================================================================

export const HERO_LEVELS = [
    { xp: 0, maxHealth: 50, maxMana: 30 }, // level 1
    { xp: 100, maxHealth: 55, maxMana: 32 },
    { xp: 250, maxHealth: 60, maxMana: 34 },
    { xp: 500, maxHealth: 67, maxMana: 37 },
    { xp: 1000, maxHealth: 75, maxMana: 39 }, // level 5
    { xp: 1500, maxHealth: 1250, maxMana: 250 } // level 6
];

export const INITIAL_HERO_INVENTORY = {
    slot1: {
        item: new Potion(POTION_LIST.potionSmallElixir),
        quantity: 1,
    },
    slot2:{
        item: new Potion(POTION_LIST.potionSmallElixir),
        quantity: 1,
    },
    slot3:{
        item: new Potion(POTION_LIST.potionSmallElixir),
        quantity: 1,
    },
    slot4:{
        item: new Potion(POTION_LIST.potionSmallElixir),
        quantity: 1,
    },
    slot5:{
        item: new Potion(POTION_LIST.potionSmallElixir),
        quantity: 1,
    },
};


// MONSTERS ===================================================================

const INITIAL_MONSTERS_INVENTORY = {
    slot1: { ...POTION_LIST.smallHP },
    slot2: null,
    slot3: null,
    slot4: null,
    slot5: null,
};

// Each entry is built via the factory so stats/attack/inventory/position are
// own per-monster objects (no shared BASE_STATS.MONSTER reference across all
// monsters, which would cascade mutations).
// Skins left null so FightDisplayBox falls back to /assets/monsters/monster_1.png
// (the previous external URLs went 404/CONNECTION_RESET in prod).
export const MONSTERS = {
    monster1: createMonster({ name: "Christelle", type: "Goule",          inventory: INITIAL_MONSTERS_INVENTORY, skin: null }),
    monster2: createMonster({ name: "Jérome",     type: "Gnome",          inventory: INITIAL_MONSTERS_INVENTORY, skin: null }),
    monster3: createMonster({ name: "Bruno",      type: "Musard",         inventory: INITIAL_MONSTERS_INVENTORY, skin: null }),
    monster4: createMonster({ name: "Ulysse",     type: "Horglup",        inventory: INITIAL_MONSTERS_INVENTORY, skin: null }),
    monster5: createMonster({ name: "u$u",        type: "Esprit frappeur", inventory: INITIAL_MONSTERS_INVENTORY, skin: null }),
}

// ITEMS ======================================================================

export const ITEMS_LIST = {
    ...POTION_LIST,
    ...EQUIPMENT_LIST,
};


